<template>
  <div class="bg" id="messageBody">
    <div class="home">
      <!-- <p class="text">เลือกคำอธิฐาน</p> -->
      <!-- <div class="text">ปีนี้ลอยอะไรทิ้งไปดี ?</div> -->
    </div>
    <div class="bg d-flex justify-content-center align-items-center">
      <div class="w-100">
        <form @submit.prevent="subMit" ref="myForm">
          <div class="home">
            <p class="text">ใส่คำอธิษฐานของคุณได้เลย!!</p>
            <b-img :src="srcimg" class="profile"></b-img>
            <label class="text-white mt-2">คำอธิษฐาน</label>
            <b-form-input
              v-model="wish"
              type="text"
              class="opacity"
              required
            ></b-form-input>
            <!-- {{ $store.state.form.zodiac }} -->
            <!-- {{ $store.state.form.location }} -->
          </div>
          <button class="d-none" type="submit" ref="submitForm"></button>
          <b-container fluid>
            <!-- <b-img
            @click="submitForm"
            src="../assets/loy.png"
            class="btn-submit"
            style="padding-bottom:50px;"
          /> -->
            <button class="base-btn btn-submit">
              ไปลอยกระทงกัน~
            </button>
          </b-container>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import baseUrl from "../util/backend";
export default {
  name: "Home",
  data() {
    return {
      srcimg: "",
      prayer: "",
      zodiac: "",
      userId: "",
      displayName: "",
      wish: "",
      pictureUrl: "",
    };
  },
  mounted() {
    this.srcimg = this.$store.state.form.srcimg;
    var messageBody = document.querySelector("#messageBody");
    messageBody.scrollTop = 0;
    console.log(this.$store.state.form);
  },
  methods: {
    // prayer1() {
    //   this.$store.dispatch("setFrom", {
    //     prayer: "1",
    //   });
    //   this.zodiac = 1;
    // },
    // prayer2() {
    //   this.$store.dispatch("setFrom", {
    //     prayer: "2",
    //   });
    //   this.zodiac = 2;
    // },
    // prayer3() {
    //   this.$store.dispatch("setFrom", {
    //     prayer: "3",
    //   });
    //   this.zodiac = 3;
    // },
    // prayer4() {
    //   this.$store.dispatch("setFrom", {
    //     prayer: "4",
    //   });
    //   this.zodiac = 4;
    // },
    // prayer5() {
    //   this.$store.dispatch("setFrom", {
    //     prayer: "5",
    //   });
    //   this.zodiac = 5;
    // },
    // prayer6() {
    //   this.$store.dispatch("setFrom", {
    //     prayer: "6",
    //   });
    //   this.zodiac = 6;
    // },
    // prayer7() {
    //   this.$store.dispatch("setFrom", {
    //     prayer: "7",
    //   });
    //   this.zodiac = 7;
    // },
    // prayer8() {
    //   this.$store.dispatch("setFrom", {
    //     prayer: "8",
    //   });
    //   this.zodiac = 8;
    // },
    // subMit() {
    //   this.$router.push("/home");
    // },
    async subMit() {
      this.$store.dispatch("setFrom", {
        wish: this.wish,
      });
      console.log(">>>>>>>>form");
      console.log(this.$store.getters.getForm);
      const submitForm = this.$store.getters.getForm;
      const res = await axios.post(`${baseUrl}/add`, {
        prayer: submitForm.wish,
        kathong_id: submitForm.kathong_id,
      });
      console.log(res);
      this.$router.replace("/loykathong");
    },
  },
};
</script>
<style scoped>
.bg {
  /* background-image: url("../assets/background.jpg"); */
  background-repeat: no-repeat;
  height: 100vh;
  /* background-size: 450px; */
  background-size: cover;
  height: 100%;
}
.profile {
  width: 150px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.textprayer {
  color: white;
}
.home {
  padding-top: 30px;
}
.opacity {
  background-color: rgba(0, 0, 0, 0.5);
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
}
.text {
  color: white;
  margin-top: 20px;
  font-size: 25px;
}
.zodiac {
  /* width: 80px; */
  height: 80px;
}
.mzodiac {
  margin-top: 30px;
}
.btn-submit {
  margin-top: 50px;
}
.active {
  border: 2px solid #58a0a8;
  border-radius: 8px;
}

input[type="text"] {
  color: white;
  text-align: center;
}
</style>
